import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.13 32.695a7.103 7.103 0 0 1-7.092-6.72 25.905 25.905 0 0 1 0-2.796 7.103 7.103 0 0 1 7.092-6.72h3.531l1.565-1.76a61.435 61.435 0 0 1 7.505-7.134l1.117-.896a3.044 3.044 0 0 1 4.936 2.096c.4 4.341.598 9.611.598 15.813 0 6.199-.199 11.467-.598 15.807a3.044 3.044 0 0 1-4.938 2.095l-1.169-.94a62.016 62.016 0 0 1-7.6-7.243l-1.417-1.602h-3.53Zm23.028 2.11a1.015 1.015 0 1 1-1.41-1.46 12.136 12.136 0 0 0 3.723-8.763 12.14 12.14 0 0 0-3.787-8.825 1.015 1.015 0 0 1 1.398-1.471A14.165 14.165 0 0 1 37.5 24.582c0 3.907-1.586 7.563-4.342 10.223Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSoundLowFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundLowFilled_default = SvgSoundLowFilled;

export { SoundLowFilled_default as default };
